module.exports = __webpack_public_path__ + "../front/img/divide1.a321c0f6.svg";